/* eslint-disable */
import React from 'react'
import Carousel from 'nuka-carousel'
import Media from 'react-media'
import { withAppContext } from '../utils/AppContext'

import InstructionsCard from './CarouselCards/InstructionsCard'
import TraitsCard from './CarouselCards/TraitsCard'
import FilterCard from './CarouselCards/FilterCard'
import TraitsCoinCard from './CarouselCards/TraitsCoinCard'
import TraitsCommanderCard from './CarouselCards/TraitsCommanderCard'
import TraitsHandCard from './CarouselCards/TraitsHandCard'
import TraitsMaesterCard from './CarouselCards/TraitsMaesterCard'
import TraitsWhisperCard from './CarouselCards/TraitsWhisperCard'
import Icon from './Icon'
import PagingDots from './PagingDots'


import styles from '../scss/ui/slider.scss'

const CarouselWrapper = ({ appContext }) => (
    <Media query="(min-width: 768px)">
        {tablet => (
            <Media query="(min-width: 1100px)">
                {desktop => {
                    let slides = 1
                    let dots = 7
                    let instructions = false
                    const slideIndex = appContext.slideIndex

                    if (desktop) {
                        slides = 3
                        dots = 6
                        instructions = true
                    } else if (tablet) {
                        slides = 2
                        dots = 7
                        instructions = true
                    }
                    return (
                        <Carousel
                            slidesToShow={slides}
                            dragging={false}
                            // swiping={true}
                            className={styles.slider}
                            slideIndex={slideIndex}
                            heightMode="max"
                            renderCenterLeftControls={({ previousSlide, currentSlide, withoutControls }) => (
                                <button
                                    onClick={previousSlide}
                                    type="button"
                                    className={currentSlide > 0 ? styles.arrowLeft : withoutControls}
                                >
                                    <Icon
                                        icon="caret-left"
                                        size={3}
                                        color="darker"
                                        className={currentSlide > 0 ? styles.arrowIcon : styles.hiddenArrowIcon}
                                    />
                                </button>
                            )}
                            renderCenterRightControls={({ nextSlide, currentSlide, withoutControls }) => (
                                <button
                                    onClick={nextSlide}
                                    type="button"
                                    className={currentSlide === dots - 1 ? withoutControls : styles.arrowRight}
                                >
                                    <Icon
                                        icon="caret-right"
                                        size={3}
                                        color="darker"
                                        className={currentSlide === dots - 1 ?
                                            styles.hiddenArrowIcon :
                                            styles.arrowIcon
                                        }
                                    />
                                </button>
                            )}
                            renderBottomCenterControls={props => <PagingDots dots={dots} {...props} />}>
                            {instructions && <InstructionsCard />}
                            <FilterCard />
                            <TraitsCard />
                            <TraitsHandCard />
                            <TraitsCoinCard />
                            <TraitsWhisperCard />
                            <TraitsCommanderCard />
                            <TraitsMaesterCard />
                        </Carousel>
                    )
                }}
            </Media>
        )}
    </Media>
)

export default withAppContext(CarouselWrapper)



// WEBPACK FOOTER //
// ./src/ui/CarouselWrapper.js